import React from 'react';

function LoadingModal({ show, loading, message = 'Carregando dados, por favor aguarde...' }) {
    const visible = show || loading;
    if (!visible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 2000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.45)',
                backdropFilter: 'blur(3px)',
                animation: 'fadeIn 0.2s ease-out',
            }}
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    borderRadius: 12,
                    padding: '2rem 2.5rem',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    minWidth: 260,
                    animation: 'scaleIn 0.2s ease-out',
                }}
            >
                <div className="spinner-border text-success" role="status" style={{ width: '2.8rem', height: '2.8rem' }}>
                    <span className="visually-hidden">Carregando...</span>
                </div>
                <p className="mb-0 text-muted small" style={{ letterSpacing: '0.02em' }}>{message}</p>
            </div>
            <style>{`
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes scaleIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
            `}</style>
        </div>
    );
}

export default LoadingModal;
